import FbImg from "assets/images/intro-1.png";
import Ticket from "assets/images/intro-2.png";
import Locker from "assets/images/intro-3.png";
import EtcImg from "assets/images/etc-img.png";

export const ShopList = [
  { text: "all" },
  { text: "festival" },
  { text: "concert" },
  { text: "exhibition" },
  { text: "Fair" },
  { text: "service" },
];

export const ShopTap = [{ text: "popularity" }, { text: "event" }];

export function inputStyle(error) {
  const borderColor = error ? "error.main" : "grey.300";
  return {
    marginTop: "0px !important",
    marginBottom: "20px",
    maxHeight: 44,
    ".MuiInputBase-root": {
      "&:focus-visible": {
        outline: "none",
      },
      "&:hover": {
        borderColor,
      },
      input: {
        fontSize: 14,
        padding: "14px",
      },
      ".MuiOutlinedInput-notchedOutline": {
        padding: "14px",
        "&[type='number']": {
          "::-webkit-outer-spin-button, ::-webkit-inner-spin-button": {
            WebkitAppearance: "none",
            margin: 0,
          },
        },
      },

      ".MuiOutlinedInput-notchedOutline": {
        fontSize: 14,
        borderColor,
        height: "52px",
      },
      "&.Mui-focused": {
        borderColor,
        ".MuiOutlinedInput-notchedOutline": {
          borderColor,
          borderWidth: "1px !important",
        },
      },
    },
  };
}

export const ScrollButtonStyle = {
  button: (boolean) => {
    return {
      position: "relative",
      display: "inline-block",
      whiteSpace: "nowrap",
      fontSize: "18px",
      fontWeight: boolean ? "bold" : "normal",
      p: "10px 0px 10px",
      mx: "12px",
      minWidth: "unset",
      color: boolean ? "primary.main" : "grey.300",
      "&:first-of-type": {
        ml: 3,
      },
      "&:last-child": {
        mr: 3,
      },
    };
  },
  box: {
    width: 4,
    height: 4,
    bgcolor: "primary.main",
    borderRadius: "50%",
    position: "absolute",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
};

export const BottomNavStyle = {
  position: "relative",
  fontWeight: 400,
  fontSize: 12,
  height: "unset",
  minWidth: "unset",
  py: 1.4,
  whiteSpace: "nowrap",
  "&.Mui-selected": {
    color: "unset",
    ".MuiBottomNavigationAction-label": {
      fontSize: 12,
      fontWeight: 700,
    },
  },
};

export const SelectItems = {
  "& .MuiSvgIcon-root": {
    color: "grey.dark",
  },
  "&:after": {
    borderBottom: "none",
  },
  "& .MuiInputBase-input": {
    color: "grey.dark",
    padding: "10px 0",
    "&:focus,&:hover": {
      bgcolor: "white",
    },
  },
};

export const SignupAgree = [
  {
    type: "essential",
    label: "service",
    key: "policy",
  },
  {
    type: "essential",
    label: "essentialAgree",
    key: "youth",
  },
  {
    type: "essential",
    label: "essentialPrivacyAgree",
    key: "privacy",
  },
  {
    type: "choice",
    label: "ChoiceAgree",
    key: "marketing",
  },
];
export const SignupAgreeEn = [
  {
    type: "essential",
    label: "I agree to all of the terms and conditions for using the service.",
    key: "policy",
  },
  {
    type: "essential",
    label: "I agree to the collection and use of my personal information.",
    key: "privacy",
  },
  {
    type: "choice",
    label: "I agree to receiving advertising information",
    key: "policyEvent",
  },
];

export const ProductInfo = [{ title: "receive" }, { title: "productInfo" }];

export const BuyOptions = [
  {
    label: "pouchAdd",
    price: "pouchPrice",
  },
  {
    label: "waterproofAdd",
    price: "waterproofPrice",
  },
];

export const BuySelectOption = [
  {
    title: "title",
  },
];

export const MypageList = [
  {
    label: "mypage:myQrTicket",
    route: "/mypage/qr-list",
  },
  {
    label: "mypage:orderList",
    route: "/mypage/order-list",
  },
  {
    label: "mypage:cancelList",
    route: "/mypage/cancel-list",
  },
  {
    label: "mypage:playList",
    route: "/mypage/myplay-list",
  },
  {
    label: "mypage:counselList",
    route: "/mypage/counsel",
  },
  {
    label: "mypage:customerCenter",
    route: "/mypage/customer-center",
    login: "unnecessary",
  },
];

export const MyInfoList = [
  {
    key: "fullname",
    label: "mypage:myinfo:name",
  },
  {
    key: "email",
    label: "mypage:myinfo:email",
  },
  {
    key: "nickname",
    label: "mypage:myinfo:nickName",
    route: "/mypage/change-nickname",
  },
  {
    key: "changePassword",
    label: "mypage:myinfo:changePassword",
    route: "/mypage/change-password",
  },
  {
    key: "mobile",
    label: "mypage:myinfo:phoneNumber",
    route: "/mypage/change-phone",
  },
  {
    key: "socialLogin",
    label: "mypage:myinfo:socialLogin",
  },
];

export const SettingList = [
  {
    key: "alarm",
    label: "mypage:setting:settingAlarm",
    caption: "mypage:setting:aboutPushAlarm",
    href: "/mypage/setting/alarm",
  },
  {
    key: "terms",
    label: "mypage:setting:terms",
    href: "/mypage/setting/terms/service",
  },
  {
    key: "privacy",
    label: "mypage:setting:privacy",
    href: "/mypage/setting/terms/privacy",
  },
  {
    key: "versionInfo",
    label: "mypage:setting:versionInfo",
    tail: "0.0.0",
  },
];

export const ListStyle = {
  display: "flex",
  justifyContent: "space-between",
  py: 2,
  px: 0,
  ":not(:last-child)": {
    borderBottom: "1px solid",
    borderColor: "grey.600",
  },

  ":hover": {
    backgroundColor: "transparent",
  },
};

export const PlayChip = [
  { title: "play:recent" },
  { title: "play:popularity" },
];

export const PlaySelect = {
  border: "1px solid",
  borderRadius: 10,
  borderColor: "grey.100",
  ".MuiSelect-iconOutlined": {
    color: "grey.100",
  },
  ".MuiSelect-select": {
    border: "none",
    borderBottom: "0 !important",
    py: 0,
  },
  ".MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
};

export const Alarms = ["이메일", "문자 메시지", "앱 푸시"];

export const MypageChipStyle = {
  px: 1.4,
  my: 1,
  overflow: "visible",
  maxHeight: "12px",
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "black",

  borderRadius: 0,
  ":not(:last-child)": {
    borderRight: "1px solid",
    borderColor: "grey.400",
  },
};

export const instaIdStyle = {
  pt: 2,
  "& input": {
    color: "grey.dark",
    fontSize: "14px",
  },
  "& input::placeholder": {
    fontSize: "14px",
    color: "grey.300",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "grey.300",
    },
    "&.Mui-focused fieldset": {
      borderColor: "grey.dark",
      border: "1px solid",
    },
    "&:hover fieldset": {
      borderColor: "grey.dark",
      border: "1px solid",
    },
  },
};
export const getState = (state, active) => {
  if (state === "point") {
    return {
      p: 0,
      px: 1,
      // bgcolor: 'primary.light',
      minHeight: 0,
      borderRadius: 0.4,
      border: "1px solid",
      bgcolor: active ? "white" : "primary.light",
      borderColor: active ? "primary.main" : "primary.light",
      color: active ? "primary.main" : "white",
      ".tagText": {
        fontWeight: active ? 700 : 400,
      },
      "&:hover": {
        bgcolor: active ? "white" : "primary.light",
      },
    };
  } else {
    return {
      p: 0,
      px: 1,
      border: "1px solid",
      bgcolor: active ? "white" : "grey.light",
      borderColor: active ? "grey.100" : "grey.light",
      minHeight: 0,
      borderRadius: 0.4,
      ".tagText": {
        color: active ? "grey.100" : "grey.200",
      },
      "&:hover": {
        bgcolor: "grey.light",
        bgcolor: active ? "white" : "grey.light",
      },
    };
  }
};

export const topTagActive = (active) => {
  return {
    color: active ? "white" : "primary.light",
    p: 0,
    whiteSpace: "nowrap",
    fontSize: 12,
    fontWeight: active ? "bold" : "normal",
    ":first-of-type": {
      ml: 2,
    },
    ":last-child": {
      mr: 2,
    },
  };
};

export const myQrTicket = [
  {
    label: "mypage:myQrCode:orderNum",
    key: "",
    value: "AW가S20",
    bold: true,
  },
  {
    label: "mypage:myQrCode:orderInfo",
    key: "",
    value: "퀸즈 스마일 010-1234-5678",
  },
  {
    label: "mypage:myQrCode:time",
    key: "",
    value: "2022.04.13 17:30",
  },
  {
    label: "mypage:myQrCode:place",
    key: "",
    value: "수령 장소",
  },
];

export const myplayBtn = [
  {
    label: "play:menu:edit",
    type: "edit",
  },
  {
    label: "play:menu:delete",
    type: "delete",
  },
];

export const postsBtn = [
  {
    label: "play:menu:report",
    type: "report",
  },
  {
    label: "play:menu:block",
    type: "block",
  },
];

export const topBtnStyle = {
  minHeight: 0,
  p: 0,
  borderColor: "grey.400",
  color: "grey.200",
  fontSize: 12,
  px: 1,
  py: 0.2,
  borderRadius: 10,
  fontWeight: 400,
  "&:hover": {
    borderColor: "grey.400",
  },
};

export const cartPayment = [
  {
    label: "바로 결제",
    value: 0,
  },
  {
    label: "다른 결제 수단",
    value: 1,
  },
];
// export const cartPaymentList = [
//   {
//     label: 'mypage:payment:phone',
//   },
//   {
//     icon: naverIcon,
//     label: 'mypage:payment:naver',
//     size: 45,
//   },
//   {
//     icon: kakaoIcon,
//     label: 'mypage:payment:kakao',
//     size: 45,
//   },
//   {
//     icon: tossIcon,
//     label: 'mypage:payment:toss',
//     size: 95,
//   },
// ];
export const EmailInputStyle = {
  maxHeight: 48,
  ".MuiSelect-select": {
    minHeight: "unset",
    maxHeight: "48px",
    borderBottom: "0 !important",
  },
  "&.Mui-focused": {
    fieldset: {
      "&.MuiOutlinedInput-notchedOutline": {
        border: "1px solid",
        borderColor: "grey.300",
      },
    },
  },
};

export const EmailSelectInputStyle = {
  position: "absolute",
  top: 0,
  width: "80%",
  overflow: "hidden",
  maxHeight: "46px",
  margin: "1px 0 0 1px !important",
  backgroundColor: "transparent",
  borderRadius: "7px 0 0 7px !important",
  ".MuiInputBase-root": {
    maxHeight: "unset",
    input: {
      fontSize: 14,
      padding: "10px 0 10px 14px",
      height: "28px",
    },
    ".MuiOutlinedInput-notchedOutline": {
      border: 0,
    },
    "&.Mui-focused": {
      ".MuiOutlinedInput-notchedOutline": {
        border: 0,
      },
    },
  },
};

export const Report = [
  {
    label: "play:report:like",
  },
  {
    label: "play:report:spam",
  },
  {
    label: "play:report:unwholesome",
  },
  {
    label: "play:report:aversion",
  },
  {
    label: "play:report:force",
  },
  {
    label: "play:report:lie",
  },
  {
    label: "play:report:fraud",
  },
  {
    label: "play:report:bully",
  },
  {
    label: "play:report:infringement",
  },
];

export const CautionList = [
  {
    label: "play:postDisallow:force",
  },
  {
    label: "play:postDisallow:Copyright",
  },
  {
    label: "play:postDisallow:spam",
  },
  {
    label: "play:postDisallow:excessive",
  },
  {
    label: "play:postDisallow:rule",
  },
];
// export const LoginSocial = [
//   {
//     label: '네이버로 시작하기',
//     sx: { bgcolor: '#03C75A', '&:hover': { bgcolor: '#03C75A' } },
//     icon: Naver,
//     type: 'naver',
//   },
//   {
//     label: '카카오로 시작하기',
//     sx: {
//       bgcolor: '#FEE500',
//       color: 'black',
//       '&:hover': { bgcolor: '#FEE500' },
//     },
//     icon: Kakao,
//     type: 'kakao',
//   },

//   {
//     label: 'Apple로 시작하기',
//     sx: { bgcolor: '#0F0F0F', '&:hover': { bgcolor: '#0F0F0F' } },
//     iconStyle: { color: 'white' },
//     icon: Apple,
//     type: 'apple',
//   },
//   {
//     label: 'Google로 시작하기',
//     sx: {
//       borderColor: 'grey.300',
//       color: 'black',
//       '&:hover': { borderColor: 'grey.300' },
//     },
//     icon: Google,
//     variant: 'outlined',
//     type: 'goolge',
//   },
// ];

// export const QrCodeStyle = {
//   image: QueensQr,
//   dotsOptions: {
//     color: '#000',
//     type: 'square',
//   },
//   imageOptions: {
//     crossOrigin: 'anonymous',
//     margin: 10,
//     imageSize: 0.5,
//   },
// };

export const PaymentInfo = [
  {
    label: "shop:complete:order",
    key: "",
    value: "후라이드 치킨 / 2개",
  },
  {
    label: "shop:complete:amount",
    key: "",
    value: "30,000원",
  },
  {
    label: "shop:complete:place",
    key: "",
    value: "워터밤 서울",
  },
  {
    label: "shop:complete:time",
    key: "",
    value: "2022.04.13 17:00",
  },
];

export const HorizonScrollStyle = {
  overflowX: "scroll",
  "::-webkit-scrollbar": {
    height: "4px",
  },
  "::-webkit-scrollbar-thumb": {
    height: "2px",
    backgroundColor: "grey.600",
    borderRadius: 5,
  },
};

export const OrderChips = [
  {
    key: "orderCancel",
    label: "mypage:orderBtn:orderCancel",
  },
  {
    key: "partialCancel",
    label: "mypage:orderBtn:partialCancel",
  },
  {
    key: "qr",
    label: "mypage:orderBtn:qrCode",
    primary: true,
  },
];

export const CancelChips = [
  {
    key: "refund",
    label: "mypage:cancelBtn:refund",
    type: "refund",
    primary: true,
  },
  {
    key: "cancelReq",
    type: "request",
    label: "mypage:cancelBtn:cancel",
  },
];

export const Platform = [
  {
    label: "50만",
    text: "누적 회원",
  },
  {
    label: "20만",
    text: "평균 MAU",
  },
  {
    label: "30개",
    text: "입점 문화 이벤트",
  },
];

export const Philosophy = [
  {
    label: "Responsible",
    text: "책임감 있는",
  },
  {
    label: "Excitement",
    text: "즐거운",
  },
  {
    label: "Open-minded",
    text: "열린 마음의",
  },
];

export const HistoryList = [
  {
    year: "2017",
    text: "(주)퀸즈스마일 설립",
  },
  {
    year: "2018",
    text: "음식 주문 중계 방법 및 실행 서버 특허 등록\n스마트 예약 부가서비스 출시",
  },
  {
    year: "2019",
    text: "교통상품 및 음식상품 중계 시스템 및 방법 특허 출원",
  },
  {
    year: "2020",
    text: "상품 주문 중계 시스템 및 방법 특허 등록\n주문 관리 서버 및 방법 특허 출원",
  },

  {
    year: "2021",
    text: "아시아 스마트관광산업 대상 수상\n문화체육관광부 성장관광벤처기업 선정",
  },
];

export const IntroList = [
  {
    title: "F&B",
    text: "시간 예약 알고리즘으로\n 대기열 없는 푸드존",
    src: FbImg,
  },
  {
    title: "E-Ticket",
    text: "입장 소요 시간 단 3초,\n 디지털 스마트 솔루션 E-Ticket",
    src: Ticket,
  },
  {
    title: "Locker",
    text: "온-오프라인\n 국내 최대 규모 물품보관소",
    src: Locker,
  },
];

export const FbText = [
  "각 시간대의 수요와 공금을 예측하고 고객과 주최사에게 예약 가능 수량 및 시간대를 전달함으로써 대기 시간을 최소화합니다.",
  "사전예약은 웹과 앱으로, 현장예약은 웹, 앱 그리고 키오스크까지 활용하여 현장 구매 트래픽을 분산 및 구매 경로를 확대해 고객 편의를 극대화합니다.",
  "주최사 및 밴더는 퀸즈 자체 개발 스토어 페이지를 활용하여 쉽고 빠르게 원하는 판매 데이터와 정보를 확인할 수 있습니다.",
];

export const FbRound = [
  {
    text: "사전 및\n현장 예약",
  },
  {
    text: "QR코드 스캔",
  },
  {
    text: "상품 수령",
  },
];

export const TicketRound = [
  {
    text: "데이터 전달\n및 등록",
  },
  {
    text: "QR티켓\n확인 및 밴딩",
  },
  {
    text: "입장",
  },
];

export const TicketList = [
  {
    text: "예매처와 부스가 분리되어 있던 기존 시스템이 아닌 찍고 입장하는 스마트 게이트를 운영합니다.",
  },
  {
    text: "E-Ticket 등록 정보로 신원 확인 및 불법 양도 방지가 가능합니다.",
  },
  {
    text: "지류 배송이 아닌 모방일 기기로 확인 가능한 티켓으로 배송비가 절감됩니다.",
  },
  {
    text: "사전 등록 현황 및 현장 시간대별 관객 입장률을 실시간으로 확인 가능하며 이에 따른 트래픽 예측 및 유연한 대응이 가능합니다.",
  },
  {
    text: "실시간 데이터에 기반한 장내 혼잡도 파악 후 안전한 행사 운영을 위한 객관적 수치를 제공합니다.",
  },
];

export const LockerItems = [
  {
    id: 0,
    label: "Locker",
    title: "온-오프라인 국내 최대 규모 물품보관소",
    src: Locker,
    text: [
      "3일 운영 기준 총 30,000개+ 보관이 가능한 물품보관소입니다.",
      "온라인 사전 예약률 90%, 3동 규모 이상 진행 가능하며\n국내 유일 온라인 판매와 오프라인 판매 동시 진행으로 구매경로를 이원화합니다.",
      "QR코드를 통한 간편한 보관 및 수령 시스템으로 공간과 시간을 함께 예약할 수 있습니다.",
    ],
  },
  {
    id: 1,
    label: "ETC",
    title: "상품의 특성에 맞춰 적용하는 스마트 예약 솔루션",
    src: EtcImg,
    text: [
      "셔틀 버스 예약 시스템 | 주차장 예약 시스템 | 굿즈샵 예약 시스템 등",
      "상품의 특성에 맞추어 퀸즈의 스마트 예약 솔루션을 다양하게 적용합니다.",
      "현장 컨디션 및 고객의 니즈 등을 반영하여 최적의 운영 경험을 제공합니다.",
    ],
  },
];
